import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  {
    headerName: 'Trip ID',
    field: 'tripId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Status',
    field: 'status',
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Passenger',
    field: 'passenger',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'pick_up_point',
    field: 'pickUpPoint',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: 'Destination',
    field: 'destination',
    width: LIST_WIDTH.xl,
  },
  { headerName: 'Trip Type', field: 'tripType', width: LIST_WIDTH.md },
  {
    headerName: 'Estimated Price',
    field: 'estimatedPrice',
    width: LIST_WIDTH.md,
  },
  { headerName: 'Driver', field: 'driver', width: LIST_WIDTH.HUMAN_NAME },
  {
    headerName: 'Last Updated At',
    field: 'lastUpdatedTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Picked Up At',
    field: 'pickUpTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Dropped Off At',
    field: 'dropOffTime',
    width: LIST_WIDTH.TIME_DATE,
  },
];
